import React, { useMemo } from "react";
import GenericFormTab from "../shippment/tabs/GenericFormTab";
import CommonDataTable from "../../components/CommonDataTable";
import {
    appointmentHeaderFields,
    asnDetailColumns,
    orderDetailColumns,
    normalizeAppointmentTypeFromApi,
} from "./formFields/appointmentFields";

function normalizeEditDate(val) {
    if (val?.$date) {
        return new Date(val.$date).toLocaleString("en-GB");
    }
    if (val && typeof val === "string") {
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? val : d.toLocaleString("en-GB");
    }
    return val ?? "";
}

/** Map API values to Inbound / Outbound for the type select */
function normalizeAppointmentType(t) {
    const s = String(t ?? "")
        .trim()
        .toLowerCase();
    if (s === "inbound" || s === "inbond") return "Inbound";
    if (s === "outbound" || s === "outbond") return "Outbound";
    return t ?? "";
}

export default function ViewAppointment({ initialValues = {}, onCancel }) {
    const headerData = useMemo(() => {
        const h = initialValues?.AppointmentHeader ?? {};
        return {
            ...h,
            AppointmentType: normalizeAppointmentType(h.AppointmentType),
            editdate: normalizeEditDate(h.editdate),
        };
    }, [initialValues]);

    const rawHeaderType =
        initialValues?.AppointmentHeader?.appointmenttype ??
        initialValues?.AppointmentHeader?.AppointmentType;
    const normalizedType = normalizeAppointmentTypeFromApi(rawHeaderType);
    const isInbound = normalizedType === "Inbound";

    const asnRows = useMemo(() => {
        const details = initialValues?.ASNDetails ?? [];
        return details.map((d, idx) => ({
            id: idx + 1,
            lineNo: idx + 1,
            AppointmentKey: d.AppointmentKey ?? "",
            ReceiptKey: d.ReceiptKey ?? "",
            ExternReceiptKey: d.ExternReceiptKey ?? "",
            Status: d.Status ?? "",
            StorerKey: d.StorerKey ?? "",
            CarrierKey: d.CarrierKey ?? "",
            ExpectedReceiptDate: d.ExpectedReceiptDate ?? "",
        }));
    }, [initialValues]);

    const orderRows = useMemo(() => {
        const details = initialValues?.OrderDetails ?? [];
        return details.map((d, idx) => ({
            id: idx + 1,
            lineNo: idx + 1,
            AppointmentKey: d.AppointmentKey ?? headerData.AppointmentKey ?? "",
            OrderKey: d.OrderKey ?? d.orderKey ?? "",
            ExternOrderKey: d.ExternOrderKey ?? d.ExternOrderNo ?? "",
            Status: d.Status ?? "",
            StorerKey: d.StorerKey ?? "",
            CarrierKey: d.CarrierKey ?? "",
            OrderDate: d.OrderDate ?? d.ExpectedShipDate ?? "",
        }));
    }, [initialValues, headerData.AppointmentKey]);

    const detailColumns = isInbound ? asnDetailColumns : orderDetailColumns;
    const detailRows = isInbound ? asnRows : orderRows;

    return (
        <>
            <div className="mb-3 border-bottom pb-2 d-flex gap-4 text-primary fw-semibold">
                <span className="text-muted">Appointment Header</span>
            </div>

            <div className="card mb-4 border-0 shadow-none">
                <div>
                    <GenericFormTab
                        fields={appointmentHeaderFields}
                        formData={headerData}
                        readOnly
                    />
                </div>
            </div>

            <div className="mb-3 border-bottom pb-2 d-flex gap-4 text-primary fw-semibold">
                <span className="text-muted">
                    {isInbound ? "ASN Details" : "Order Details"}
                </span>
            </div>

            <CommonDataTable
                id="appointment-details-view"
                allPossibleColumns={detailColumns}
                initialVisible={detailColumns.map((c) => c.field)}
                initialRows={detailRows}
                height={380}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                checkboxSelection={false}
                enableImportButton={false}
                enableExportButton={false}
                forInventory={false}
                readOnly
            />

            <div className="d-flex justify-content-center mt-4">
                <button className="btn btn-secondary" onClick={onCancel}>
                    Back
                </button>
            </div>
        </>
    );
}
